var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17.5,
    stroke: "#2D2926"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C16 24.6025 16.4884 25.0909 17.0909 25.0909H22.9091V30.9091C22.9091 31.5116 23.3975 32 24 32C24.6025 32 25.0909 31.5116 25.0909 30.9091V25.0909L30.9091 25.0909C31.5116 25.0909 32 24.6025 32 24C32 23.3975 31.5116 22.9091 30.9091 22.9091L25.0909 22.9091V17.0909C25.0909 16.4884 24.6025 16 24 16C23.3975 16 22.9091 16.4884 22.9091 17.0909L22.9091 22.9091H17.0909C16.4884 22.9091 16 23.3975 16 24Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.d34c8625b0025daa3d179345913427f0.svg";
export { ForwardRef as ReactComponent };